import { render, staticRenderFns } from "./SKUWithStockListItem.vue?vue&type=template&id=564d2ca7&scoped=true&"
import script from "./SKUWithStockListItem.vue?vue&type=script&lang=js&"
export * from "./SKUWithStockListItem.vue?vue&type=script&lang=js&"
import style0 from "./SKUWithStockListItem.vue?vue&type=style&index=0&id=564d2ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d2ca7",
  null
  
)

export default component.exports